import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Box,
  Stack,
  Button,
  Typography,
  Switch,
  Hidden,
} from "@mui/material";
import { GridSelectionModel } from "@mui/x-data-grid";
import { GridActionsCellItem, GridRowId } from "@mui/x-data-grid-pro";

import Item from "../../Template/Item";
import WithPermission from "../../components/WithPermission";
import TableSkeleton from "../../components/TableSkeleton";
import Dilogbox from "../../components/Dilogbox";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirm } from "react-confirm-box";
import { PeopleForm } from "./people-form";
import { InvitationForm } from "./invitation-form";
import { StaffForm } from "./staff-form";
import { Link } from "react-router-dom";
import {
  loadPeople,
  trashPeople,
  blukTrashPeople,
  updatePeopleStatus,
  timesheetLimitWarn,
} from "../../redux/actions/people.actions";
import { storeStateType } from "../../redux/store";
import { MultiFiltersType } from "../Worktype/Worktype";
import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import { IPeople } from "../../redux/reducers/people.reducer";
import { checkStringFormat } from "../../utility";

// type dataType = {
//   id: string;
//   guid: string;
//   first_name: string;
//   middle_name: string | null;
//   last_name: string;
//   username: string;
//   address: string;
//   mobile_number: string;
//   date_of_birth: string;
//   is_superuser: boolean;
//   is_active: boolean;
//   is_staff: boolean;
//   user_role: string;
//   visa_type: string;
//   timesheet_limit: number;
//   group: string;
//   //company_name: string,
// };

const customOptions = {
  render: (
    message: string,
    onConfirm: React.MouseEventHandler<HTMLButtonElement>,
    onCancel: React.MouseEventHandler<HTMLButtonElement>
  ) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
};

export default function People() {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState<number>(1);
  const [selectionModel, setSelectionModel] =
    React.useState<GridSelectionModel>([]);
  const { users, user, total, loading } = useSelector(
    (state: storeStateType) => state.people
  );

  // const auth = useSelector((state: storeStateType) => state.auth);
  // const ui = useSelector((state: storeStateType) => state.UI);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isOpen_, setIsOpen_] = React.useState<boolean>(false);
  const [isOpen_2, setIsOpen_2] = React.useState<boolean>(false);
  const [editRequest, setEditRequest] = React.useState<boolean>(false);
  const [trashState, setTrashState] = React.useState<boolean>(true);
  const [handelaction] = React.useState<string>("");
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [filterData, setFilterrData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
  });
  const [csvData] = React.useState([]);
  const csvDownloadBtn = React.useRef<any>();
  const csvHeaders = [
    { label: "Name", key: "fullname" },
    { label: "Address", key: "address" },
    { label: "Email", key: "email" },
    { label: "Contact", key: "mobile_number" },
    { label: "Role", key: "user_role" },
    { label: "DOB", key: "date_of_birth" },
  ];
  useEffect(() => {
    if (user && editRequest) {
      setIsOpen(true);
      setEditRequest(false);
    }
  }, [user, editRequest]);

  useEffect(() => {
    dispatch<any>(loadPeople(page, filterData));
  }, [dispatch, page, pageSize, filterData]);

  const columns = [
    {
      field: "fullname",
      headerName: "Full Name",
      width: 300,
      flex: 0.8,
      valueGetter: (params: any) => `${params.row["fullname"]}`,
      renderCell: (params: any) => (
        <Link to={`/employee/profile/${params.id}`}>
          {params.value!.toString()}
        </Link>
      ),
    },
    {
      field: "address",
      headerName: "Address",
      flex: 0.8,
      width: 300,
      valueGetter: (params: any) => {
        if (checkStringFormat(`${params.row["address"]}`) === "json_object") {
          let addressObject = JSON.parse(`${params.row["address"]}`);

          return `${addressObject?.addressName}`;
        } else {
          return `${params.row["address"]}`;
        }
      },
    },

    { field: "contact", headerName: "Contact", width: 200 },
    {
      field: "group",
      headerName: "Role",
      flex: 0.5,
      valueGetter: (params: any) => {
        let value = params.row["user_role"];
        let capitalizedStr = "";
        if (value) {
          capitalizedStr = value.charAt(0).toUpperCase() + value.slice(1);
        }
        return capitalizedStr ? capitalizedStr : "-";
      },
    },
    // {
    //   field: "group",
    //   headerName: "Role",
    //   flex: 0.5,
    //   valueGetter: (params: any) => {
    //     let value = params.row["role_type"];
    //     let capitalizedStr = "";
    //     if (value) {
    //       capitalizedStr = value.charAt(0).toUpperCase() + value.slice(1);
    //     }
    //     return capitalizedStr ? capitalizedStr : "-";
    //   },
    // },

    {
      field: "visa_type",
      headerName: "Visa-type",
      width: 120,
      valueGetter: (params: any) => {
        let value = params.row["visa_type"];
        let formattedValue = "";
        if (value) {
          formattedValue = value
            .split("-")
            .map(
              (word: string) => word.charAt(0)?.toUpperCase() + word?.slice(1)
            )
            .join(" ");
        }

        return `${formattedValue ? formattedValue : "-"}`;
      },
    },

    {
      field: "timesheet_limit",
      headerName: "Limit exceed warn",
      width: 100,
      filterable: false,
      flex: 0.2,

      renderCell: (params: any) => {
        let canChange = false;
        if (params.row?.visa_type === "student-visa") {
          canChange = true;
        }

        return (
          <Switch
            {...label}
            defaultChecked={
              parseInt(params.row?.timesheet_limit_warn) ? true : false
            }
            disabled={!canChange}
            onChange={(e) => handleWarnStudentChange(e, params.row.id)}
          />
        );
      },
    },
    {
      field: "is_active",
      headerName: "Active",
      width: 100,
      filterable: false,
      flex: 0.2,

      renderCell: (params: any) => (
        <Switch
          {...label}
          defaultChecked={params.row.is_active}
          disabled={params.row.is_superuser}
          onChange={(e) => handleChange(e, params.row.id)}
        />
      ),
    },

    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          disabled={params.row.is_superuser}
          showInMenu
          onClick={deleteUser(params.id, customOptions)}
        />,
      ],
    },
  ];

  const label = { inputProps: { "aria-label": "Switch people" } };

  const deleteUser = React.useCallback(
    (id: GridRowId, options: any) => async () => {
      const result = await confirm("Are you sure you want to delete?", options);
      if (result) {
        dispatch<any>(trashPeople(id));
        setSelectionModel([]);
        return;
      }
    },
    [dispatch]
  );

  // const editUser = React.useCallback(
  //   (id: GridRowId) => async () => {
  //     setHandelaction("Edit People");
  //     dispatch<any>(getPeople(id));
  //     setEditRequest(true);
  //   },
  //   [dispatch]
  // );

  let rows =
    Array.isArray(users) && users?.length >= 0
      ? users.map((obj: IPeople) => {
          return {
            id: obj.id,
            fullname: obj?.fullname ?? "",
            address: obj.address,
            contact: obj.mobile_number,
            is_superuser: obj.is_superuser,
            user_role: obj.user_role,
            visa_type: obj.visa_type,
            timesheet_limit_warn: obj.timesheet_limit_warn,
            //company: obj.company_name,
            is_active: obj.is_active,
          };
        })
      : [];

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: string
  ) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append("is_active", data);
    dispatch<any>(updatePeopleStatus(formData, clickedRow));
  };
  const handleWarnStudentChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: string
  ) => {
    const formData = new FormData();
    const isChecked: any = event.target.checked;
    if (isChecked) {
      formData.append("timesheet_warn", "1");
    } else {
      formData.append("timesheet_warn", "0");
    }
    dispatch<any>(timesheetLimitWarn(clickedRow, formData, page, filterData));
  };

  const handleClickOpen = () => {
    setIsOpen_(!isOpen_);
  };

  const handleClickOpen2 = () => {
    setIsOpen_2(!isOpen_2);
  };

  useEffect(() => {
    if (csvData.length) {
      csvDownloadBtn.current.link.click();
    }
  }, [csvData]);

  const handleTrash = async (option: any) => {
    const result = await confirm("Are you sure you want to delete?", option);
    if (result) {
      const id = {
        data: {
          id: selectionModel,
        },
      };
      dispatch<any>(blukTrashPeople(id));
      return;
    }
  };

  const handleClosePeopleForm = useCallback(() => {
    setIsOpen(false);
  }, []);
  const closeStaffFormModal = useCallback(() => setIsOpen_2(false), []);
  const closeInvitationModal = useCallback(() => setIsOpen_(false), []);
  return (
    <WithPermission
      roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
      message="Access Denied"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              flexWrap={"wrap"}
              mb={2}
            >
              <Typography
                variant="h6"
                fontSize={"1.67rem"}
                gutterBottom
                m={1}
                textTransform="capitalize"
              >
                Employee
              </Typography>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                flexWrap="wrap"
                gap={2}
                sx={{ whiteSpace: "nowrap" }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleClickOpen()}
                  startIcon={<AddIcon />}
                >
                  Invitation
                </Button>

                <Button
                  variant="contained"
                  onClick={() => handleClickOpen2()}
                  startIcon={<AddIcon />}
                >
                  {/* {`${menus["employee"]}`} */}
                  Staff
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleTrash(customOptions)}
                  disabled={trashState}
                  startIcon={<DeleteIcon />}
                >
                  <Hidden smDown>Trash</Hidden>
                </Button>
              </Box>
            </Stack>
            <Box sx={{ height: 700, width: "100%" }}>
              {rows ? (
                <CustomDataGridPro
                  totalRows={total}
                  rows={rows}
                  columns={columns}
                  pageLimit={pageSize}
                  currentPage={page}
                  handleRowSelectionModelChange={(
                    newSelectionModel: React.SetStateAction<GridSelectionModel>
                  ) => {
                    newSelectionModel.length
                      ? setTrashState(false)
                      : setTrashState(true);
                    setSelectionModel(newSelectionModel);
                  }}
                  disableRowSelectionOnClick={true}
                  exportCSVUrl="/user/csv"
                  defaultCSVExport={false}
                  filterData={filterData}
                  setFilterData={setFilterrData}
                  setCurrentPage={setPage}
                  loading={loading}
                  setPageLimit={setPageSize}
                  csvHeaders={csvHeaders}
                  csvFilename={"Employee"}
                />
              ) : (
                <TableSkeleton />
              )}
            </Box>
          </Item>
        </Grid>
        <InvitationForm
          isDialogOpened={isOpen_}
          handleCloseDialog={closeInvitationModal}
        />
        <PeopleForm
          isDialogOpened={isOpen}
          handleCloseDialog={handleClosePeopleForm}
          action={handelaction}
        />
        <StaffForm
          title={"Add new staff"}
          isDialogOpened={isOpen_2}
          handleCloseDialog={closeStaffFormModal}
        />
      </Grid>
    </WithPermission>
  );
}
